module.exports = __webpack_public_path__ + "static/media/bausch-health.e8be3a8d.jpg";